'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.synchronize = synchronize;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SYNCHRONIZATION = 'cms-jai20enmaths/widgets/SYNCHRONIZATION';
var SYNCHRONIZATION_SUCCESS = 'cms-jai20enmaths/widgets/SYNCHRONIZATION_SUCCESS';
var SYNCHRONIZATION_FAIL = 'cms-jai20enmaths/widgets/SYNCHRONIZATION_FAIL';

var initialState = {
  synchronizing: false,
  error: undefined,
  report: undefined
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SYNCHRONIZATION:
      return (0, _extends3.default)({}, state, {
        synchronizing: true,
        report: undefined
      });
    case SYNCHRONIZATION_SUCCESS:
      return (0, _extends3.default)({}, state, {
        synchronizing: false,
        error: undefined,
        report: action.result
      });
    case SYNCHRONIZATION_FAIL:
      return (0, _extends3.default)({}, state, {
        synchronizing: false,
        error: action.error,
        report: undefined
      });
    default:
      return state;
  }
}

function synchronize() {
  return {
    types: [SYNCHRONIZATION, SYNCHRONIZATION_SUCCESS, SYNCHRONIZATION_SUCCESS],
    promise: function promise(client) {
      return client.post('/stage/synchronize');
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/synchronization.js
// module id = 597
// module chunks = 0